import { useCallback, useEffect } from "react";

import queryString from "query-string";
import uamServices from "@tvg/api/uam";

import { getPromosInfo } from "../utils/handlers";
import {
  setAPromotionRegistrationAction,
  setInvalidPromoRegistrationAction,
  setSelectedPromotionRegistrationAction
} from "../actions";
import { onPromoCodeAppliedAutomaticallyGtmEvent } from "../utils/gtm/promoCode";

const useWelcomePromoSetup = ({
  dispatch,
  selectedPromo,
  promoCodesMap,
  referAFriendRegistrationCode
}) => {
  const params = useCallback(() => {
    const paramsParsed = queryString.parse(location?.search);
    return Object.keys(paramsParsed).reduce(
      (acc, key) => ({
        ...acc,
        [key.toLowerCase()]: paramsParsed[key]
      }),
      {}
    );
  }, []);

  useEffect(() => {
    const { rcode, promocode } = params();
    const promoReference =
      promocode || `${referAFriendRegistrationCode}-${rcode}`;

    if (
      (rcode || promocode) &&
      !selectedPromo.code &&
      Object.keys(promoCodesMap).length
    ) {
      uamServices
        .getPromoValidation(promoReference)
        .then(({ data }) => {
          const promoId = promocode ? promocode.toUpperCase() : "raf";
          const { response } = data;
          const promoInfo = getPromosInfo({
            stringCode: promoReference,
            promoResponse: response,
            message: promoCodesMap,
            isRafCode: rcode
          });

          dispatch(setAPromotionRegistrationAction(promoId, promoInfo));
          dispatch(setSelectedPromotionRegistrationAction(promoId));
          onPromoCodeAppliedAutomaticallyGtmEvent(
            "Personal Details",
            promoInfo.promoReference
          );
        })
        .catch(() => {
          dispatch(setInvalidPromoRegistrationAction(true));
        });
    }
  }, [referAFriendRegistrationCode, JSON.stringify(promoCodesMap)]);
};

export default useWelcomePromoSetup;
